import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getStockInfoData } from '../../../../../services/api';
import { rel } from '../../../../../utils/rel';

class Stock extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        data: [0, 0, 0, 0],
    };

    async componentDidMount() {
        const {
            content: { code },
        } = this.props;

        try {
            const data = await getStockInfoData([code]);

            if (data && data[code]) {
                this.setState({
                    data: data[code],
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { data } = this.state;
        const {
            content: { url, src, name },
        } = this.props;

        let styleName = 'blank';

        if (data[3] > 0) {
            styleName = 'red';
        } else if (data[3] < 0) {
            styleName = 'green';
        }

        return (
            <div className={styles.stock_box}>
                <div className={styles.stock}>
                    <a href={url} target="_blank" rel={rel}>
                        <img src={src} />
                    </a>
                </div>
                <div className={styles.stock_info}>
                    <a href={url} target="_blank" rel={rel}>
                        {name}
                    </a>
                    <p className={`${styles.price} ${styles[styleName]}`}>{data[0]}</p>
                    <p className={`${styles.info} ${styles[styleName]}`}>
                        <span>{`${data[2] > 0 ? `+${data[2]}` : data[2]}`} </span>
                        <span>{`${data[3] > 0 ? `+${data[3]}` : data[3]}%`}</span>
                    </p>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Stock);
